import { Tabs } from '@mantine/core'
import { useNavigate, useParams } from 'react-router-dom'
import { Navigation } from './components'
import { AuditView } from './components/cpg/AuditView'
import { DocumentsView } from './components/cpg/DocumentsView'
import { FamiliesView } from './components/cpg/FamiliesView'
import { MeasuresView } from './components/cpg/MeasuresView'
import { ReviewQueue } from './components/cpg/ReviewQueue'
import { XwalkRules } from './components/cpg/XwalkRules'

const VIEWS = [
  { value: 'review', label: 'Review Queue' },
  { value: 'documents', label: 'Documents' },
  { value: 'families', label: 'Families' },
  { value: 'measures', label: 'Measures' },
  { value: 'xwalk', label: 'Xwalk Rules' },
  { value: 'audit', label: 'Audit' },
] as const

type View = (typeof VIEWS)[number]['value']

/**
 * Super Admin → CPG: the clinical practice guideline registry console (docs/cpg/CPG_ADMIN.md).
 * Review Queue = the human gate (confirm LLM family suggestions, then activate — the only
 * human lifecycle transition); Documents = the full corpus; Families = the registry the
 * classifier maps into; Measures = the named risks and care gaps the Risks & Gaps agent
 * reports against; Xwalk Rules = patient↔family matching codes; Audit = the edit trail.
 * The active view lives in the URL (/super/cpg/:view) so queue items are deep-linkable.
 */
export function Cpg() {
  const navigate = useNavigate()
  const { view: viewParam } = useParams()
  const view: View = VIEWS.some((v) => v.value === viewParam) ? (viewParam as View) : 'review'

  return (
    <>
      <Navigation />
      <div className="flex flex-col" style={{ height: 'calc(100vh - 112px)' }}>
        <Tabs
          value={view}
          onChange={(value) => value && navigate(`/super/cpg/${value}`)}
          className="shrink-0"
        >
          <Tabs.List>
            {VIEWS.map((v) => (
              <Tabs.Tab value={v.value} key={v.value}>
                {v.label}
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </Tabs>
        <div className="min-h-0 flex-1">
          {view === 'review' && <ReviewQueue />}
          {view === 'documents' && <DocumentsView />}
          {view === 'families' && <FamiliesView />}
          {view === 'measures' && <MeasuresView />}
          {view === 'xwalk' && <XwalkRules />}
          {view === 'audit' && <AuditView />}
        </div>
      </div>
    </>
  )
}
